module.exports = __webpack_public_path__ + "static/media/books2.48c967c2.jpg";